import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const BASE = process.env.REACT_APP_BACKEND_URL;

export function useLogoLabel(logo, brand) {
  return useQuery({
    queryKey: ["logo-label", logo || "", brand || ""],
    queryFn: async () => (await api.get("/logo-labels/match", { params: { logo, brand } })).data?.match || null,
    enabled: !!(logo || "").trim(),
    staleTime: 10 * 60 * 1000,
  });
}

export const logoLabelUrl = (m) => `${BASE}/api/logo-labels/${m.file_id}/image`;

// Small centred preview of the real label photo; tap → full-size pop-up.
// Renders nothing when the Drive folder has no file matching the logo name.
export function LogoLabelPreview({ logo, brand, className = "h-28 w-40", testid = "logo-label" }) {
  const { data: m } = useLogoLabel(logo, brand);
  const [open, setOpen] = useState(false);
  if (!m) return null;
  const url = logoLabelUrl(m);
  return (
    <>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        title={`${m.name} · tap to enlarge`}
        data-testid={testid}
        className={`${className} shrink-0 flex items-center justify-center rounded-lg border-2 border-slate-200 bg-white shadow-sm overflow-hidden hover:border-slate-400 transition-colors`}
      >
        <img src={url} alt={m.name} className="max-h-full max-w-full object-contain" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl" data-testid={`${testid}-dialog`}>
          <DialogHeader>
            <DialogTitle className="font-mono text-base">{m.name} <span className="text-slate-400 font-normal">· {m.brand}</span></DialogTitle>
          </DialogHeader>
          <img src={url} alt={m.name} className="w-full max-h-[75vh] object-contain rounded-md bg-slate-50" data-testid={`${testid}-full`} />
        </DialogContent>
      </Dialog>
    </>
  );
}
